<template >
    <div v-if="showMessage" @contextmenu.prevent="openMenu($event, message)">
        <div :class="message.belong ? 'text-body-my' : 'text-body'">
            <!-- :key 变化强制重建组件触发重新请求；src 带时间戳参数绕过失败/过期缓存 -->
            <previewImage :key="reloadKey" class="image-box" :src="imgSrc" />
        </div>
        <!-- <div style="margin-top: 10px; font-size: 12px; color:#ed2616;" ><a :href="message.messageUrl+'?response-content-type=application/octet-stream'" download >点击下载</a></div> -->
        <div style="display: flex;">
            <div class="down-link-cs" v-down="message">点击下载</div>
            <div class="down-link-cs" style="margin-left: 12px;" @click="reloadImage">重新加载</div>
        </div>

    </div>
</template>
<script>
import previewImage from '@/components/elimage.vue'
export default {
    name: 'ImgMessage',
    components: {
        previewImage
    },
    props:{
        message: {
            type: Object,
            default: null
        }
    },
    data() {
      return {
        showMessage:false,
        imgSrc:this.message && this.message.messageUrl ? this.message.messageUrl : '',
        reloadKey:0
      }
    },
    watch:{
        'message.messageUrl'(v){
            //消息对象被更新(如撤回/重推)时跟随重置
            this.imgSrc = v || ''
            this.reloadKey++
        }
    },
    mounted () {
        this.showMessage = true
    },
    methods:{
        openMenu(event,item){
            console.log("右键事件最底层")
            this.$emit('openMenu',{event:event,item:item})
        },
        //重新加载图片：剔除旧的刷新参数后追加时间戳，绕过浏览器缓存重新请求
        reloadImage(){
            if(!this.message || !this.message.messageUrl){
                return
            }
            let url = this.message.messageUrl
            url = url.replace(/([?&])_r=\d+/, '$1').replace(/[?&]$/,'')
            url += (url.indexOf('?') >= 0 ? '&' : '?') + '_r=' + Date.now()
            this.imgSrc = url
            this.reloadKey++
        },
    }
}
</script>
<style scoped>
.text-body {
  max-width: 100%;
  opacity: 1;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #222222;
  text-align: left;
  margin-left: 10px;
  border-radius: 0px 10px 10px 10px;
  padding: 10px;
  background: #eeeeee;
  margin-top: 6px;
}
.text-body-my {
  max-width: 100%;
  opacity: 1;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #222222;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px 0px 10px 10px;
  padding: 10px;
  background: #fff3e8;
  margin-top: 6px;
}
.text-body p {
  margin-bottom: 0px !important;
}
.text-body-my p {
  margin-bottom: 0px !important;
}
.image-box {
  width: 100px;
}
.down-link-cs{
  margin-top: 10px; font-size: 12px; color:#ed2616;
}
</style>